// @flow

import window from 'window';

import { resolveContextConfig } from './context-config';
import { default as browserDetector } from 'browser-type-detector';

import type { StatisticsHeadersInterface } from 'server2';

const getStatisticsHeaders = (): StatisticsHeadersInterface => {
	let appHeader = '';
	let platformHeader = '';

	const isEmpMode = resolveContextConfig().isEmpMode;
	if (isEmpMode) {
		appHeader = 'mobileapp';
		// DmsThirdPartyService to get info
		const isAndroid = window.AndroidJS;
		const isIos = window.webkit && window.webkit.messageHandlers;
		if (isAndroid) {
			platformHeader = 'android';
		}
		if (isIos) {
			platformHeader = 'ios';
		}
	} else {
		const isAndroid = browserDetector.isAndroid();
		const isIos = browserDetector.isIOS();
		if (isAndroid) {
			platformHeader = 'android';
		}
		if (isIos) {
			platformHeader = 'ios';
		}
		const isPwaMode = browserDetector.isStandalonePwa();
		if (isPwaMode) {
			appHeader = 'pwa';
		} else {
			appHeader = 'web';
		}
	}

	return {
		'source-app': appHeader,
		'source-platform': platformHeader,
	};
};

export {
	getStatisticsHeaders,
};
